import { Button } from 'react-bootstrap';
import * as React from 'react';
import { isEmpty } from 'lodash';

interface IQuoteStepButtonsProps {
  valid?: boolean;
  submitting: boolean;
  submitFailed: boolean;
  hasBackButton?: boolean;
  handleBack?: () => any;
  disable?: boolean;
  submitButtonType?: string;
  submitTitle?: string;
  callback?: () => any;
  onClick?: () => any;
  synchronousError?: any;
  checkForErrors?: boolean;
  disableBack?: boolean;
  submit?: (name: string) => Promise<any>;
}

export const QuoteStepButtons = ({
                                   submitting,
                                   submitFailed,
                                   valid = true,
                                   handleBack = null,
                                   hasBackButton = false,
                                   disable = false,
                                   submitButtonType = 'submit',
                                   submitTitle = 'CONTINUE',
                                   callback = null,
                                   onClick = null,
                                   synchronousError = null,
                                   checkForErrors = false,
                                   disableBack= false,
                                   submit = null,
                                 }: IQuoteStepButtonsProps) => {

  const checkForErrorsBeforeSubmit = () => {
    Promise.resolve(submit('quote')).then(() => {
      if (synchronousError && !isEmpty(synchronousError)) {
        window.scrollTo(0, 0);
      }
    })
  }

  return (
    <div className={'quote-button-bar'}>
      <div className={'back-button'}>
        {hasBackButton && (
          <Button
            id="back"
            className={'admiral-primary-btn'}
            bsSize="small"
            block={true}
            type="button"
            onClick={handleBack}
            disabled={submitting || disableBack}
          >
            BACK
          </Button>
        )}
      </div>
      <div className={'continue-button'}>
        {submitButtonType === 'submit' && (
          <Button
            id="continue"
            className={'admiral-secondary-btn'}
            bsSize="small"
            block={true}
            type={'submit'}
            disabled={submitting || (submitFailed && !valid) || disable}
          >
            {submitTitle}
          </Button>
        )}

        {submitButtonType === 'payment' && (
          <Button
            id="continue"
            className={'admiral-secondary-btn'}
            bsSize="small"
            block={true}
            type={'button'}
            onClick={onClick}
            disabled={submitting || (submitFailed && !valid) || disable}
          >
            {submitTitle}
          </Button>
        )}

        {(submitButtonType === 'button' && callback) && (
          <Button
            id="continue"
            className={'admiral-secondary-btn'}
            bsSize="small"
            block={true}
            type={'button'}
            onClick={callback}
            disabled={submitting || (submitFailed && !valid) || disable}
          >
            {submitTitle}
          </Button>
        )}

        {submitButtonType === 'validateButton' && checkForErrors && submit && (
          <Button
            id="continue"
            className={'admiral-secondary-btn'}
            bsSize="small"
            block={true}
            type={'button'}
            onClick={checkForErrorsBeforeSubmit}
            disabled={submitting || (submitFailed && !valid) || disable}
          >
            {submitTitle}
          </Button>
        )}
      </div>
    </div>
  )
}
